import React from 'react';
import SectionText from '../../presentational/SectionText';
import data from '../../../core/data';
import Image from '../../presentational/Image';

function PorcelainIntroContainer(props) {
  const heading = data.bbcream.porcelainIntro.heading;
  return (
    <section className="image-bg" id="porcelain">
      <div className="container">
        <h1>White GOLD <br/> for your skin</h1>
      </div>
    </section>
  )
}

export default PorcelainIntroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/BBPage/PorcelainIntroContainer.jsx
 **/